var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 14,
    viewBox: "0 0 19 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenod",
    d: "M18.4925 1.85989C18.4905 1.78333 18.4695 1.71103 18.4505 1.63766C18.4355 1.57599 18.4285 1.51325 18.4035 1.4569C18.3805 1.40161 18.3415 1.35695 18.3075 1.30591C18.2655 1.24105 18.2275 1.17619 18.1735 1.12303C18.1645 1.11346 18.1605 1.1007 18.1505 1.09219C18.1145 1.05923 18.0705 1.04753 18.0315 1.02095C17.9715 0.979482 17.9125 0.93695 17.8445 0.909305C17.7775 0.883786 17.7115 0.877406 17.6425 0.866773C17.5945 0.85933 17.5515 0.835938 17.5005 0.835938H12.5005C11.9475 0.835938 11.5005 1.31229 11.5005 1.89923C11.5005 2.48617 11.9475 2.96252 12.5005 2.96252H15.3265L11.2905 7.96849L7.0145 5.24115C6.5915 4.96895 6.0475 5.0689 5.7315 5.47189L0.731495 11.8516C0.378495 12.3025 0.435495 12.9734 0.859495 13.3487C1.0475 13.5146 1.2735 13.5954 1.4995 13.5954C1.7865 13.5954 2.0705 13.4657 2.2685 13.2126L6.7205 7.53254L10.9855 10.2546C11.4045 10.5215 11.9425 10.4279 12.2595 10.0345L16.5005 4.7733V7.21568C16.5005 7.80262 16.9475 8.27898 17.5005 8.27898C18.0535 8.27898 18.5005 7.80262 18.5005 7.21568V1.89923C18.5005 1.88541 18.4935 1.87371 18.4925 1.85989Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyArrow);
export default __webpack_public_path__ + "static/media/buy-arrow.f8f01a4ed47367680aa903aa8617e8cf.svg";
export { ForwardRef as ReactComponent };